module.exports = __webpack_public_path__ + "static/media/report_and_additional_services.67bbc5c4.svg";